<div class="page-selection">
  <ul class="selection">
    <li (click)="onFirstPageClicked()" [ngClass]="{'disabled': initialPage <= 1}">
      <i class="material-icons">first_page</i>
    </li>
    <li (click)="onPreviousPageClicked()" [ngClass]="{'disabled': initialPage <= 1}">
      <i class="material-icons">chevron_left</i>
    </li>
    <li
      *ngFor="let pageNumber of pages.slice(startIndex, endIndex)"
      [class.active]="pageNumber === initialPage"
      (click)="onPageNumberClicked(pageNumber)">
      <span>{{pageNumber}}</span>
    </li>
    <li (click)="onNextPageClicked()" [ngClass]="{'disabled': initialPage >= maxPages}">
      <i class="material-icons">chevron_right</i>
    </li>
    <li (click)="onLastPageClicked()" [ngClass]="{'disabled': initialPage >= maxPages}">
      <i class="material-icons">last_page</i>
    </li>
  </ul>
</div>
<div *ngIf="!hideEntrySelection" class="entry-selection">
  <p class="pag">Showing {{getElementsNumber()}} entries out of {{this.itemsLength}}</p>
  <mat-select [value]="selectedPageSize" (selectionChange)="onPageSizeChanged($event)">
    <mat-option *ngFor="let page of pageSize" [value]="page">{{page}}</mat-option>
  </mat-select>
</div>

